import classNames from 'classnames';
import React from 'react';

import {BrowseCourse} from '@udemy/browse-course';
import {InDemandCareer} from '@udemy/career-academies';
import {useI18n} from '@udemy/i18n';
import {ContentArea, ContentGrid, ContentGridItem} from '@udemy/react-layout-components';

import {Disclaimer} from '../disclaimer/disclaimer.react-component';
import {PurchaseCTA} from '../purchase-cta/purchase-cta.react-component';
import {CertificateBanner} from './certificate-modules/certificate-banner.react-component';
import styles from './certificate.module.less';

interface CertificateProps {
    academy: InDemandCareer;
    courses?: BrowseCourse[];
    isUSMarketplace: boolean;
}

export function Certificate({
    academy,
    courses,
    isUSMarketplace,
}: CertificateProps): JSX.Element | null {
    const {gettext} = useI18n();

    if (!academy?.hasCertificate) {
        return null;
    }

    return (
        <section className={styles.wrapper} aria-labelledby="certificate-heading">
            <ContentArea className={classNames('ud-container', styles.area)}>
                <ContentGrid className={styles.container}>
                    <ContentGridItem
                        defaultColumn={'1 / span 4'}
                        mdColumn={'1 / span 7'}
                        lgColumn={'2 / span 6'}
                    >
                        <CertificateBanner />
                    </ContentGridItem>
                    <ContentGridItem
                        defaultColumn={'1 / span 4'}
                        mdColumn={'8 / span 5'}
                        lgColumn={'8 / span 4'}
                        className={styles['get-started']}
                    >
                        <h2 id="certificate-heading" className="ud-heading-xl">
                            {gettext('Ready to launch your new career?')}
                        </h2>

                        <PurchaseCTA
                            academy={academy}
                            uiRegion={'career_academies_certificates'}
                            courses={courses}
                            containerClassName={styles['purchase-cta-container']}
                            subscriberCountClassName={styles['subscriber-count']}
                            className={styles['purchase-cta']}
                        />
                    </ContentGridItem>
                    {isUSMarketplace && (
                        <ContentGridItem
                            defaultColumn={'1 / span 4'}
                            mdColumn={'1 / span 12'}
                            lgColumn={'2 / span 10'}
                            className="ud-text-xs"
                        >
                            <Disclaimer />
                        </ContentGridItem>
                    )}
                </ContentGrid>
            </ContentArea>
        </section>
    );
}
